<template>
  <div class="terms container my-5">
    <TermsContent />
  </div>
</template>

<script>
import TermsContent from '@/views/TermsContent.vue'

export default {
  name: 'TermsPrivacy',
  components: { TermsContent }
}
</script>

<style scoped lang="scss">
.terms {
  margin-top: calc(var(--header-height, 58px) + 12px);
  text-align: start;

  h1, h2, h3, h4 {
    color: black !important;
  }

  p, li {
    line-height: 1.8;
    color: #222;
  }

  .muted {
    color: #666;
  }

  ol, ul {
    padding-left: 1.2em;
  }

  .foot-actions {
    margin-top: 8px;
  }
}
</style>
